module.exports = __webpack_public_path__ + "img/edi.870a33aa.png";